<template>
    <div>
        <div class="card">
            <div class="card-header">教学资料管理</div>
            <div class="card-body" v-if="resourceFileData.length===0">
                <div class="alert alert-warning mb-0">教学班级还没有可供下载的教学资料<template v-if="canEdit">，请添加</template></div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 30%">文件名</th>
                    <th class="text-center align-middle" style="width: 20%">文件类型</th>
                    <th class="text-center align-middle" :style="{width: canEdit? '30%': '40%'}">备注</th>
                    <th class="text-center align-middle" style="width: 10%" v-if="canEdit">编辑</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file, index) in resourceFileData" :key="file.attFileId">
                    <td class="text-center align-middle">{{ index + 1 }}</td>
                    <td class="text-left align-middle">
                        <a :href="URL_DOWNLOAD + file.attFileId" target="_blank">{{ file.sourceFileName }}</a>
                    </td>
                    <td class="text-center align-middle">{{ file.attFileCategoryName }}</td>
                    <td class="text-left align-middle">{{ file.memo }}</td>
                    <td class="text-center align-middle" v-if="canEdit">
                        <button class="btn btn-danger" @click="btnDeleteAttFile(file.attFileId)">删除</button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="card-footer text-center" v-if="canEdit">
                <button class="btn btn-primary" @click="btnUpload_Click()">上传</button>
                <input type="file" name="uploadFile" style="display: none"
                       ref="uploadFile" @change="uploadFileChange">
            </div>
        </div>

        <b-modal v-model="isAddAttFileDialogOpen"
                 title="添加批次文件"
                 ok-title="确定" cancel-title="取消" @ok="addAttFileInfoDialog_OK"
                 :no-close-on-backdrop="true">
            <div class="form-group row">
                <label for="inputAttSourceFileName" class="col-sm-3 col-form-label text-right">文件名</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttSourceFileName"
                           v-model="addAttFileInfo.sourceFileName" disabled>
                </div>
            </div>
            <div class="form-group row">
                <label for="inputAttAddress" class="col-sm-3 col-form-label text-right">附件地址</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" id="inputAttAddress" v-model="addAttFileInfo.address"
                           disabled>
                </div>
            </div>
            <div class="form-group row mb-0">
                <label for="inputAttMemo" class="col-sm-3 col-form-label text-right">备注</label>
                <div class="col-sm-8">
                        <textarea type="text" class="form-control" id="inputAttMemo" placeholder="备注"
                                  v-model="addAttFileInfo.memo" rows="3"></textarea>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import url from "@/utils/api/url";
import dictionary from "@/utils/dictionary";
import commonApi from "@/utils/api/common";
export default {
    name: "ClassTrainingResourceEdit",
    props: {
        classId: {type: String, required: true},
        canEdit: {type: Boolean, required: false, default: false}
    },
    data: function () {
        return {
            URL_DOWNLOAD: url.URL_DOWNLOAD,
            resourceFileData: [],

            addAttFileInfo: {
                attFileCategory: dictionary.attFileCategory.CLASS_TRAINING_RESOURCE_FILE,
                ownerId: this.classId,
                userId: this.$store.state.userInfo.userId,
                userName: this.$store.state.userInfo.userName,
                userType: this.$store.state.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: dictionary.attFileType.OTHER_FILE,
                memo: ''
            },
            isAddAttFileDialogOpen: false,
        };
    },
    mounted() {
        this.getResourceFileData();
    },
    methods: {
        getResourceFileData() {
            commonApi.attFile.getAttFileData(this.classId, dictionary.attFileCategory.CLASS_TRAINING_RESOURCE_FILE).then(res => {
                this.resourceFileData = res.data;
            });
        },

        btnUpload_Click(achievementId) {
            this.currentAchievementId = achievementId;

            this.addAttFileInfo = {
                attFileCategory: dictionary.attFileCategory.CLASS_TRAINING_RESOURCE_FILE,
                ownerId: this.classId,
                userId: this.$store.state.userInfo.userId,
                userName: this.$store.state.userInfo.userName,
                userType: this.$store.state.userType,
                fileName: '',
                sourceFileName: '',
                path: '',
                address: '',
                physicalPath: '',
                physicalAddress: '',
                fileType: dictionary.attFileType.OTHER_FILE,
                memo: ''
            };
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'TrainingResource').then(res => {
                let info = res.data;

                this.addAttFileInfo.fileName = info.fileName;
                this.addAttFileInfo.sourceFileName = info.sourceFileName;
                this.addAttFileInfo.path = info.path;
                this.addAttFileInfo.address = info.address;
                this.addAttFileInfo.physicalPath = info.physicalPath;
                this.addAttFileInfo.physicalAddress = info.physicalAddress;
                if (info.fileName.toLowerCase().endsWith('.pdf')) {
                    this.addAttFileInfo.fileType = dictionary.attFileType.PDF_FILE
                }

                this.isAddAttFileDialogOpen = true;
                this.$refs.uploadFile.value = ''
            });
        },
        addAttFileInfoDialog_OK() {
            commonApi.attFile.insertAttFileInfo(this.addAttFileInfo).then(res => {
                this.getResourceFileData();
                this.isAddAttFileDialogOpen = false
            });
        },
        btnDeleteAttFile(attFileId) {
            if (confirm('是否删除此附件文件？')) {
                commonApi.attFile.deleteAttFileInfoById(attFileId).then(res => {
                    this.getResourceFileData();
                });
            }
        },
    }
}
</script>

<style scoped>

</style>